import React from 'react';

import type { ReactNode } from 'react';
import type { ViewProps } from 'react-native';

import { ContentContainer } from './styles';

interface ContentProps extends ViewProps {
  children: ReactNode;
}

export default function Content({ children, ...rest}: ContentProps) {
  return <ContentContainer {...rest}>{children}</ContentContainer>;
}
